<script setup lang="ts">
import type { PropType } from "vue";
import type { Collection } from "~/types";
import moment from "moment";
import useCollectionAiredData from "~/composables/useCollectionAiredData";
import { ChipBg } from "~/types";
import { getThumbnailImage } from "~/utils/common";

const props = defineProps({
  episode: {
    type: Object as PropType<Collection>,
    required: true,
  },
});

const { chipInfo } = useCollectionAiredData(props.episode);
</script>

<template>
  <div>
    <div
      class="before-b-border relative mb-5 border-b border-b-white pb-3 text-lg font-bold"
    >
      Latest Episode
    </div>
    <NuxtLink
      :to="getCollectionLink({ type: episode.type, slug: episode.label })"
      class="flex cursor-pointer flex-col gap-5 rounded-md p-4 hover:bg-black lg:flex-row"
    >
      <div class="flex-shrink-0">
        <NuxtImg
          class="aspect-video w-44 rounded object-cover object-center"
          :src="
            getThumbnailImage([
              episode?.images || [],
              episode?.pre_air_images || [],
            ])
          "
          alt="pokergo-logo"
          placeholder="/images/placeholder.png"
          loading="lazy"
        />
      </div>
      <div class="flex flex-col justify-around gap-2">
        <div v-if="chipInfo.label">
          <PgChip
            :icon="chipInfo.icon"
            :label="chipInfo.label"
            :bg="chipInfo.bg"
          />
        </div>
        <div
          class="flex flex-col-reverse justify-between text-xs lg:flex-row lg:items-center"
        >
          <div class="mt-2 text-lg font-semibold lg:mt-0">
            {{ episode?.title }}
          </div>
          <div class="flex items-center gap-2">
            <PgChip
              v-if="episode.duration"
              :label="`${Math.floor(moment.duration(episode.duration, 'seconds').asMinutes())}min`"
              :icon="['far', 'clock']"
              :bg="ChipBg.TRANSPARENT"
            />
            <PgChip
              :label="`Released ${moment(episode.aired_at).format('MMM DD')}`"
              :bg="ChipBg.GRAY"
            />
          </div>
        </div>
        <div class="text-xs">
          {{ episode?.description }}
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<style scoped>
.before-b-border::before {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100px;
  height: 5px;
  background-color: var(--p-primary-200);
}
</style>
